import { Core } from '.generated/templates/Foundation.Core.model';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { classnames } from 'tailwindcss-classnames';
import HeadingTag from 'components/helpers/HeadingTag';
import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import { IsNmdpSite } from 'lib/util/site-configuration';

type PageTitleProps = {
  params?: {
    colorType?: string;
  };
};

export type PageTitleFieldProps = PageTitleProps & {
  fields?: {
    pageTitle?: {
      value?: string;
    };
  };
};

export const PageTitleWithField = ({ params, fields }: PageTitleFieldProps): JSX.Element => {
  // Fail out if we don't have any fields
  if (!fields) {
    return <MissingDataSource />;
  }

  let colorType = (params?.colorType ?? '').toLowerCase();
  if (IsNmdpSite() && (colorType === 'default' || colorType === '')) {
    colorType = 'night';
  }

  const pageTitleClasses = classnames({
    'page-title': true,
    [colorType.toLowerCase()]: true,
  });

  return (
    <div data-component="authorable/Heroes/pagetitle" className={pageTitleClasses}>
      <LayoutPageSectionShell theme="theme-navy-blue">
        <div className={classnames('heading-xl', 'line-clamp-2')}>
          <HeadingTag headingLevel="h1">
            <Text tag="" field={fields.pageTitle} />
          </HeadingTag>
        </div>
      </LayoutPageSectionShell>
    </div>
  );
};

const PageTitle = ({ params }: PageTitleProps): JSX.Element => {
  const sitecoreContext = useSitecoreContext();

  const { fields } = sitecoreContext.sitecoreContext
    .route as unknown as Core.BaseTemplates.Routes.Fields.BasePageInfo;

  return <PageTitleWithField params={params} fields={fields} />;
};

export default PageTitle;
